import { ChangeDetectionStrategy, Component, HostBinding, input, output, ViewEncapsulation } from '@angular/core';
import { ChevronComponent } from '@shared/chevron/chevron.component';

@Component({
    selector: 'companyid-prev-next-buttons',
    imports: [ChevronComponent],
    templateUrl: './prev-next-buttons.component.html',
    styleUrl: './prev-next-buttons.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrevNextButtonsComponent {
    public currentItemIndex = input.required<number>();
    public contentItemsLength = input.required<number>();

    public onChangeSlide = output<number>();

    @HostBinding('class')
    public readonly hostClassname = 'flex justify-between w-full';

    public nextItem(): void {
        this.emitSlideChange(1);
    }

    public prevItem(): void {
        this.emitSlideChange(-1);
    }

    private emitSlideChange(delta: number): void {
        const newIndex = (this.currentItemIndex() + delta + this.contentItemsLength()) % this.contentItemsLength();
        this.onChangeSlide.emit(newIndex);
    }
}
